import { useState, useEffect } from "react";
// Router
import { NavLink, withRouter } from "react-router-dom";
// Redux
import { connect } from "react-redux";
import { showModal } from "../../redux/actions/modal";
// import { rolesDataSummary } from "./../../models/roles-data";
import Tabs from "../Tabs/Tabs";
import ManageProducts from "./ManageProducts/ManageProducts";
import ManageAggregatorSettings from "./ManageAggregatorSettings/ManageAggregatorSettings";
import ManageGlobalSettings from "./ManageGlobalSettings/ManageGlobalSettings";
import ManageLocalLiquidationSettings from "./ManageLocalLiquidationSettings/ManageLocalLiquidationSettings";
import { appInsights } from "../../config/appInsights";
import ManageChangeSignatoryContainer from "./ManageChangeApproval/ManageChangeSignatoryContainer";

const ManageApproval = (props) => {
  const [activeTab, setActiveTab] = useState("products");

  const tabs = [
    {
      name: "Manage Products ",
      id: "products",
      icon: "fas fa-users",
      identifier: "approvalTab",
    },
    {
      name: "Aggregator Settings",
      id: "settings",
      icon: "fas fa-users-cog",
      identifier: "approvalTab",
    },
    {
      name: "Global Settings",
      id: "global-settings",
      icon: "fas fa-globe",
      identifier: "approvalTab",
    },
    {
      name: "Local Liquidation Settings",
      id: "liquidation-settings",
      icon: "fas fa-money",
      identifier: "approvalTab",
    },
    {
      name: "Signatory Settings",
      id: "signatory-settings",
      icon: "fas fa-signature",
      identifier: "approvalTab",
    },
  ];

  // Life Cycle Hooks
  useEffect(() => {
    // If user is not authenticates, redirect to login
    if (!props.isAuthenticated) {
      props.history.push("/login");
    }
  }, [props.history, props.isAuthenticated]);

  useEffect(() => {
    appInsights.trackPageView({
      name: "Setup Approvals - (ManageApproval.jsx)",
      isLoggedIn: true,
    });
  }, []);

  //JSX Template
  return (
    <div className="ManageRoles datatable-wrapper">
      <div className="table-view">
        {/*User & roles Stats*/}
        <div className="row grid__padding animated fadeInRight">
          <div className="col-lg-12 col-md-12 col-sm-12 dashboard-title flex__row">
            <h3 className="m-l-1 relax-left">
              <aside className="rounder">
                <i className="fas fa-check-circle" />
              </aside>
              &nbsp; Manage Approvals
            </h3>
            <div className="breadcrumb__location">
              <NavLink to="dashboard">
                <h3 className="breadcrumb__location__title">Dashboard</h3>
              </NavLink>
              <span className="breadcrumb__location__icon">
                <i className="fas fa-angle-double-right" />
              </span>

              <NavLink to="manage-approvals">
                <h3 className="breadcrumb__location__title">
                  Manage Approvals
                </h3>
              </NavLink>
            </div>
          </div>
        </div>

        <div className="row m-x-1 m-t-md">
          <Tabs onContentToggle={(e) => setActiveTab(e)} tabs={tabs} />
        </div>

        {/*Datatables*/}
        {(() => {
          switch (activeTab) {
            case "products":
              return <ManageProducts />;
            case "settings":
              return <ManageAggregatorSettings />;
            case "global-settings":
              return <ManageGlobalSettings />;
            case "liquidation-settings":
              return <ManageLocalLiquidationSettings />;
            case "signatory-settings":
              return <ManageChangeSignatoryContainer />;

            default:
              return null;
          }
        })()}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const { isAuthenticated, loggedInUser } = state.authReducer;

  return {
    isAuthenticated,
    loggedInUser,
  };
};

export default withRouter(
  connect(mapStateToProps, { showModal })(ManageApproval)
);
